import { render } from "./UserSigninView.vue?vue&type=template&id=45887dc0&scoped=true"
import script from "./UserSigninView.vue?vue&type=script&lang=js"
export * from "./UserSigninView.vue?vue&type=script&lang=js"

import "./UserSigninView.vue?vue&type=style&index=0&id=45887dc0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45887dc0"]])

export default __exports__